import { useContext } from "react"; 
import CartContext from "./CartContextProvider";
import { LectureSummaryModel } from "../generated/api";
 

export function useShoppingUtility() {
  const { cartItems, addToCart, removeFromCart, isItemInCart,clearCart } = useContext(CartContext);
  
  const getLectures = ():LectureSummaryModel[] => {
    return cartItems;
  };

  const addLecture = (lecture: LectureSummaryModel) => {
      addToCart(lecture);
  };

  const removeLecture = (lectureToken?: string) => {
      removeFromCart(lectureToken); 
  };

  const clearAllLectures = () => {
    clearCart(); 
  };

  const isExistCart = (lectureToken?: string): boolean => {
      return isItemInCart(lectureToken); 
  };

  return { cartItems, addLecture, removeLecture, isExistCart,getLectures,clearAllLectures };
}